class detailRedInfoCtrl {
    constructor($scope, $http, $uibModal, logger, httpRequest, $state, sweetalert, globalFn) {
        // 如果是控制台则增加样式
        if ($state.current.name.indexOf('workspace') > -1) {
            $scope.haveBorder = true
        }
        $scope.totalInvoice = 1
        $scope.currentInvoice = 1
        $scope.infoId = $state.params.infoId
        let paramArr = []
        if ($state.params.infoId) {
            paramArr = $state.params.infoId.split('options')
            $scope.infoId = paramArr[0]
            if (paramArr.length > 1) {
                const invoiceArr = JSON.parse(paramArr[1])
                $scope.totalInvoice = invoiceArr.length
                $scope.currentInvoice = invoiceArr.indexOf($scope.infoId) + 1
            }
        }
        $scope.showOperateBtn = function (flag) {
            $scope.showOperate = flag
            if ($scope.currentInvoice > 1 && $scope.currentInvoice < $scope.totalInvoice) {
                $scope.showOperateLeft = true
                $scope.showOperateRight = true
            } else if ($scope.currentInvoice > 1) {
                $scope.showOperateLeft = true
                $scope.showOperateRight = false
            } else if ($scope.currentInvoice < $scope.totalInvoice) {
                $scope.showOperateLeft = false
                $scope.showOperateRight = true
            }
        }
        // 翻页按钮
        $scope.changepage = function (val) {
            const list = JSON.parse(paramArr[1])
            if (val > 0) {
                $state.go('workspace.item.redinfo', { infoId: `${list[$scope.currentInvoice]}options${JSON.stringify(list)}` })
            } else {
                $state.go('workspace.item.redinfo', { infoId: `${list[$scope.currentInvoice - 2]}options${JSON.stringify(list)}` })
            }
        }
        // 隐藏一二级菜单
        $('#wrapper').addClass('invoiceDetailPage')
        $scope.$on('$stateChangeStart', () => {
            $('#wrapper').removeClass('invoiceDetailPage')
        })

        // 初始化表单数据
        const _infoId = $scope.infoId
        if (_infoId === 'undefined') {
            //  $location.path("outputManage/ovat/redInfo/list").replace();
            $state.go('outputManage.FOManage.redInfo.list')
        }
        let redAmount = 0 // 可红冲金额
        $scope.param = {
            adValoremTotal: 0,
            applicant: '1',
            applyReason: '',
            billCode: '',
            billId: '',
            blueInvoiceCode: '',
            blueInvoiceNumber: '',
            busSysId: '',
            busSysName: '',
            checker: '',
            createUser: '',
            custAddress: '',
            custBank: '',
            custBankAccount: '',
            custCreditCode: '',
            custMobile: '',
            custName: '',
            custPhone: '',
            description: '',
            diskCode: '',
            diskId: 0,
            extendInfo: '',
            infoCode: '',
            infoId: '',
            infoSerialNo: '',
            infoSource: '',
            infoStatus: 'TZD0500',
            invoiceCode: '',
            invoiceNumber: '',
            isBlueList: '',
            isChineseSecurity: $scope.userInfo.sale.isChineseSecurity,
            isPrint: '',
            matName: '',
            openPeople: $scope.userInfo.user.realName,
            payee: '',
            projectId: '',
            projectName: '',
            remark: '',
            saleAddress: $scope.userInfo.sale.businessAddress,
            salePhone: $scope.userInfo.sale.phone,
            saleBank: $scope.userInfo.sale.saleBankAccount.bank,
            saleBankAccount: $scope.userInfo.sale.saleBankAccount.bankAccount,
            saleCreditCode: $scope.userInfo.sale.saleCreditCode,
            saleId: $scope.userInfo.sale.saleId,
            saleName: $scope.userInfo.sale.saleName,
            signature: '',
            state: 0,
            statusDescribe: '',
            taxRate: '',
            tenantId: 0,
            totalAmt: 0,
            totalTaxamt: 0,
            ukeyCode: '',
            ukeyId: 0,
            workflowStatus: '0',
            isTax: '1',
            ovatRedDetailDTOList: [],
        }
        // 精确n位小数
        function _toFixed(v, n) {
            return parseFloat(v).toFixed(n)
        }
        // 获取数据
        // 获取单条信息
        httpRequest.get_getOvatRedInfoById({
            infoId: _infoId,
        }).then((res) => {
            $scope.param = $.extend({}, $scope.param, res.data.value)
            $scope.param.saleBank = $scope.param.saleBank + ' ' + $scope.param.saleBankAccount
            $scope.param.saleAddress = $scope.param.saleAddress + ' ' + $scope.param.salePhone
            calTotalAmtTotalTaxamt()
            taxChange($scope.param.isTax)
            // 此处只处理小数点问题
            const { ovatRedDetailDTOList } = $scope.param
            if (ovatRedDetailDTOList != null && ovatRedDetailDTOList != undefined && ovatRedDetailDTOList.length != 0) {
                for (let i = 0, l = ovatRedDetailDTOList.length; i < l; i++) {
                    ovatRedDetailDTOList[i].amount = _toFixed(ovatRedDetailDTOList[i].amount, 2)
                    ovatRedDetailDTOList[i].adValoremTotal = _toFixed(ovatRedDetailDTOList[i].adValoremTotal, 2)
                    ovatRedDetailDTOList[i].taxAmount = _toFixed(ovatRedDetailDTOList[i].taxAmount, 2)
                }
            }
        })
        // 是否新增
        $scope.isOperatedAdd = false
        // 税率默认含税
        $scope.isTaxText = '含税'
        // 明细行
        function initovatRedDetailDTOListParam() {
            $scope.ovatRedDetailDTOListParam = {
                adValoremTotal: 0,
                amount: 0,
                balance: 0,
                extendInfo: '',
                infoDetailId: '',
                infoId: '',
                isPrivilege: '',
                isTax: '',
                matName: '',
                ownCoding: '',
                price: 0,
                privilegeType: '',
                quantity: 0,
                revenueCode: '',
                revenueName: '',
                revenueVersion: '',
                serialNo: 0,
                spec: '',
                taxAmount: 0,
                taxPrice: 0,
                taxRate: 0,
                tenantId: 0,
                unit: '',
                zeroTax: '',
            }
        }
        initovatRedDetailDTOListParam()
        // 开票点数据
        $scope.ukeyList = $scope.userInfo.sysUkeyList
        $scope.param.ukeyId = $scope.ukeyList[0].ukeyId
        $scope.param.ukeyCode = $scope.ukeyList[0].ukeyCode
        $scope.param.diskCode = $scope.ukeyList[0].diskCode
        $scope.param.diskId = $scope.ukeyList[0].diskId
        // 获取ukeyCode
        $scope.changerUkeyId = function () {
            const _ukeyList = $scope.ukeyList
            for (let i = 0, l = _ukeyList.length; i < l; i++) {
                if (_ukeyList[i].ukeyId === $scope.param.ukeyId) {
                    $scope.param.ukeyId = $scope.ukeyList[i].ukeyId
                    $scope.param.ukeyCode = $scope.ukeyList[i].ukeyCode
                    $scope.param.diskCode = $scope.ukeyList[i].diskCode
                    $scope.param.diskId = $scope.ukeyList[i].diskId
                    break
                }
            }
        }

        // 申请方类型选择
        $scope.applicationObject = []
        // 数字字典
        httpRequest.get_dictByTypeArr(['red_info_applicant']).then((res) => {
            $scope.dictData = res.data.value
        })
        // 是否含税
        $scope.isTaxChange = taxChange
        function taxChange(v) {
            $scope.param.isTax = v
            if ($scope.param.isTax === '0') {
                $scope.isTaxText = '不含税'
            } else {
                $scope.isTaxText = '含税'
            }
        }

        // 根据蓝票号码和代码生成红字信息表
        $scope.getRedInfoByBlueInvoice = function () {
            if ($scope.param.blueInvoiceCode == '' && $scope.param.blueInvoiceNumber == '') {
                logger.logError('请输入蓝票代码或号码!')
                return
            }
            httpRequest.post_getRedInfoByBlueInvoice({
                blueInvoiceCode: $scope.param.blueInvoiceCode,
                blueInvoiceNumber: $scope.param.blueInvoiceNumber,
            }).then((res) => {
                // 回写干啥
                const _res = res.data
                if (!_res.success) {
                    logger.logError(_res.message)
                    return
                }
                const item = _res.value
                // 销方信息
                $scope.param.saleAddress = item.businessAddress
                $scope.param.salePhone = item.phone
                $scope.param.saleBank = item.saleBankAccount.bank
                $scope.param.saleBankAccount = item.saleBankAccount.bankAccount
                $scope.param.saleCreditCode = item.saleCreditCode
                $scope.param.saleId = item.saleId
                $scope.param.saleName = item.saleName
                // 商品明细
                $scope.param.ovatRedDetailDTOList = item.ovatRedDetailDTOList
                // 购方信息
                $scope.param.custAddress = item.custAddress
                $scope.param.custBank = item.custBank
                $scope.param.custBankAccount = item.custBankAccount
                $scope.param.custCreditCode = item.custCreditCode
                $scope.param.custMobile = item.custMobile
                $scope.param.custName = item.custName
                $scope.param.custPhone = item.custPhone

                // 收款人
                $scope.param.payee = item.payee

                $scope.param.blueInvoiceCode = item.invoiceCode
                $scope.param.blueInvoiceNumber = item.invoiceNumber
                // 可红冲金额
                redAmount = item.redAmount
                // 红冲备注
                $scope.param.remark = `申请人：${item.openPeople}对应正数发票代码:${item.invoiceCode}号码:${item.invoiceNumber}`

                // 接口已处理负数问题
                // if ($scope.param.ovatRedDetailDTOList !=null && $scope.param.ovatRedDetailDTOList.length > 0) {
                //  for (var i = 0,l = $scope.param.ovatRedDetailDTOList.length ; i < l; i++) {
                //      $scope.param.ovatRedDetailDTOList[i].amount = -$scope.param.ovatRedDetailDTOList[i].amount;
                //      $scope.param.ovatRedDetailDTOList[i].adValoremTotal = -$scope.param.ovatRedDetailDTOList[i].adValoremTotal;
                //      $scope.param.ovatRedDetailDTOList[i].quantity = -$scope.param.ovatRedDetailDTOList[i].quantity;
                //      $scope.param.ovatRedDetailDTOList[i].taxAmount = -$scope.param.ovatRedDetailDTOList[i].taxAmount;
                //  }
                //  calTotalAmtTotalTaxamt();
                // }
                calTotalAmtTotalTaxamt()
            })
        }

        // 计算金额/税额合计 税价合计
        function calTotalAmtTotalTaxamt() {
            const ovatRedDetailDTOListLth = $scope.param.ovatRedDetailDTOList.length
            if (ovatRedDetailDTOListLth > 0) {
                $scope.param.totalAmt = 0
                $scope.param.totalTaxamt = 0
                for (let i = 0; i < ovatRedDetailDTOListLth; i++) {
                    $scope.param.totalAmt = globalFn.Add($scope.param.totalAmt, $scope.param.ovatRedDetailDTOList[i].amount)
                    $scope.param.totalTaxamt = globalFn.Add($scope.param.totalTaxamt, $scope.param.ovatRedDetailDTOList[i].taxAmount)
                }
                $scope.param.adValoremTotal = globalFn.Add($scope.param.totalAmt, $scope.param.totalTaxamt)
                $scope.adValoremTotalChinese = globalFn.digitUppercase($scope.param.adValoremTotal)
            } else {
                $scope.param.totalAmt = 0
                $scope.param.totalTaxamt = 0
                $scope.param.adValoremTotal = 0
                $scope.adValoremTotalChinese = globalFn.digitUppercase($scope.param.adValoremTotal)
            }
        }
        calTotalAmtTotalTaxamt()

        // 新增商品行
        $scope.operatedAdd = function () {
            // 差额征税的商品明细只能开具一行！
            // 判断商品是否为null
            if ($scope.param.ovatRedDetailDTOList == null) {
                $scope.param.ovatRedDetailDTOList = []
            }
            if (hasBalanced()) {
                logger.logError('差额征税的商品明细只能开具一行！')
                return
            }
            // 开票申请单上的商品明细行不超过8行。超过8行自动勾选清单
            const goodsMaxCol = 8
            if ($scope.param.ovatRedDetailDTOList.length > goodsMaxCol) {
                hasListModal()
                return
            }
            $scope.isOperatedAdd = true
        }
        // 取消新增
        $scope.cancelGoodsTr = function () {
            $scope.isOperatedAdd = false
        }
        // 是否差额
        function hasBalanced() {
            return ($scope.param.ovatRedDetailDTOList.length == 1 || $scope.param.ovatRedDetailDTOList.length == 2) && $scope.param.ovatRedDetailDTOList[0].balance != 0
        }

        // 主商品名和税率
        function matNameAndRate() {
            const ovatRedDetailDTOListLth = $scope.param.ovatRedDetailDTOList.length
            if ($scope.param.ovatRedDetailDTOList.length === 0) {
                return
            }
            if ($scope.param.ovatRedDetailDTOList.length === 1) {
                $scope.param.taxRate = $scope.param.ovatRedDetailDTOList[0].taxRate
                $scope.param.matName = $scope.param.ovatRedDetailDTOList[0].matName
                return
            }
            // 是否多税率
            let isMulRate = false
            $scope.param.matName = $scope.param.ovatRedDetailDTOList[0].matName
            const newRateArr = $scope.param.ovatRedDetailDTOList.map((item) => item.taxRate)
            for (let i = 0, l = newRateArr.length - 1; i < l; i++) {
                if (newRateArr[i] == newRateArr[i + 1]) {
                    isMulRate = true
                }
            }
            if (isMulRate) {
                $scope.param.taxRate = ''
                return
            }
            $scope.param.taxRate = $scope.param.ovatRedDetailDTOList[0].taxRate
        }

        // 确定新增行
        $scope.addGoodsTr = function () {
            // 判断商品是否为null
            if ($scope.param.ovatRedDetailDTOList == null) {
                $scope.param.ovatRedDetailDTOList = []
            }
            if ($scope.ovatRedDetailDTOListParam.matName == '') {
                logger.logError('商品名称不能为空')
                return
            }
            if (!isAdValoremTotal() || !isAmount()) {
                logger.logError('商品金额不合法')
                return
            }
            // 校正通过
            const ovatRedDetailDTOListParamLen = $scope.param.ovatRedDetailDTOList.length
            let initGoodsId = 0
            if (ovatRedDetailDTOListParamLen > 0) {
                initGoodsId = $scope.param.ovatRedDetailDTOList[ovatRedDetailDTOListParamLen - 1].serialNo
            }
            initGoodsId++
            $scope.ovatRedDetailDTOListParam.serialNo = initGoodsId
            const _ovatRedDetailDTOListParam = $.extend({}, $scope.ovatRedDetailDTOListParam)
            $scope.param.ovatRedDetailDTOList.push(_ovatRedDetailDTOListParam)
            $scope.isOperatedAdd = false
            initovatRedDetailDTOListParam()
            calTotalAmtTotalTaxamt()
            matNameAndRate()
            // 开票申请单上的商品明细行不超过8行。超过8行自动勾选清单
            const goodsMaxCol = 8
            if ($scope.param.ovatRedDetailDTOList !== null && $scope.param.ovatRedDetailDTOList.length > goodsMaxCol) {
                hasListModal()
            }
        }
        // 商品行自动补全
        $scope.goodsNameCodeVal = ''
        $scope.qryTaxClassList = function (val) {
            return $http.post(`${host.etcloudOvat}settings/sysGoodsInfo/getGoodsInfoList`, val).then((response) => response.data.value.map((item) => $.extend({}, {
                goodsCodeAndGoodsName: `${item.goodsCode}<span class="typeahead-taxname">${item.goodsName}</span>` + `<span class="typeahead-taxname">${item.taxRate * 100}%</span>`,
            }, item)))
        }
        // 选中行
        $scope.qryTaxClassInfo = function ($item, $model, $label, $event) {
            $scope.ovatRedDetailDTOListParam.taxRate = $item.taxRate
            $scope.ovatRedDetailDTOListParam.isPrivilege = $item.isPrivilege
            $scope.ovatRedDetailDTOListParam.matCode = $item.goodsCode
            $scope.ovatRedDetailDTOListParam.matName = $item.goodsName
            $scope.ovatRedDetailDTOListParam.typeName = $item.matCalss
            $scope.ovatRedDetailDTOListParam.revenueCode = $item.taxMergeCode
            $scope.ovatRedDetailDTOListParam.revenueName = $item.taxShortName
            $scope.ovatRedDetailDTOListParam.revenueVersion = $item.codeVersions
            $scope.ovatRedDetailDTOListParam.privilegeType = $item.privilegeType
            $scope.ovatRedDetailDTOListParam.isPrivilege = $item.isPrivilege
            $scope.ovatRedDetailDTOListParam.isTax = $item.taxInclud
            $scope.ovatRedDetailDTOListParam.unit = $item.measureUnit
            $scope.ovatRedDetailDTOListParam.spec = $item.specifications
            $scope.ovatRedDetailDTOListParam.taxAmount = 0
            $scope.ovatRedDetailDTOListParam.adValoremTotal = 0
            $scope.ovatRedDetailDTOListParam.amount = 0
            if ($item.taxInclud === '1') {
                $scope.ovatRedDetailDTOListParam.taxPrice = $item.price
                $scope.ovatRedDetailDTOListParam.price = globalFn.Div($item.price, globalFn.Add(1, $item.taxRate))
            } else {
                $scope.ovatRedDetailDTOListParam.taxPrice = globalFn.Mul($item.price, globalFn.Add(1, $item.taxRate))
                $scope.ovatRedDetailDTOListParam.price = $item.price
            }
        }
        // 购方模块自动补全POST /
        $scope.qryCustNameList = function (val) {
            return $http.post(`${host.etcloudOvat}settings/sysCustomer/getPageCustomerList`, {
                pageNum: 1,
                pageSize: 100000,
                param: {
                    customerName: val,
                    orgId: $scope.userInfo.user.currentOrgId,
                    status: '',
                    taxplayerType: '',
                },
            }).then((response) => response.data.value.list.map((item) => $.extend({}, {
                custCodeAndcustName: `${item.customerName} ${item.customerCode}`,
            }, item)))
        }
        // 选中行
        $scope.qryCustNameInfo = function ($item, $model, $label, $event) {
            $scope.param.custName = $item.customerName
            $scope.param.custCreditCode = $item.creditCode
            $scope.param.custAddress = $item.businessAddress
            $scope.param.custPhone = $item.phone
            $scope.param.buyerBank = $item.bank
            $scope.param.buyerBankAccount = $item.bankAccount
            $scope.param.custCode = $item.customerCode
            $scope.param.creditType = `0${$item.taxplayerType}`
        }

        // 匹配是否正确不含税单价
        function isPrice() {
            return globalFn.isPositiveFloatNum($scope.ovatRedDetailDTOListParam.price) && $scope.ovatRedDetailDTOListParam.price !== 0
        }
        // 是否含税
        function isTax() {
            return $scope.param.isTax === '1'
        }
        // 匹配是否正确含税单价
        function isTaxPrice() {
            return globalFn.isPositiveFloatNum($scope.ovatRedDetailDTOListParam.taxPrice) && $scope.ovatRedDetailDTOListParam.taxPrice !== 0
        }
        // 是否正确数字
        function isQuantity() {
            return globalFn.isNegativeFloatNum($scope.ovatRedDetailDTOListParam.quantity) && $scope.ovatRedDetailDTOListParam.quantity !== 0
        }
        // 是否正确不含税金额
        function isAmount() {
            return globalFn.isNegativeFloatNum($scope.ovatRedDetailDTOListParam.amount) && $scope.ovatRedDetailDTOListParam.amount !== 0
        }
        // 是否正确含税金额
        function isAdValoremTotal() {
            return globalFn.isNegativeFloatNum($scope.ovatRedDetailDTOListParam.adValoremTotal) && $scope.ovatRedDetailDTOListParam.adValoremTotal !== 0
        }
        // 计算税额
        function calTaxAmount() {
            $scope.ovatRedDetailDTOListParam.taxAmount = globalFn.Mul($scope.ovatRedDetailDTOListParam.amount, $scope.ovatRedDetailDTOListParam.taxRate)
        }
        // 数量变化
        $scope.quantityChange = function () {
            if (isTax()) {
                if (!isQuantity()) {
                    $scope.ovatRedDetailDTOListParam.quantity = ''
                    return
                }
                if (isTaxPrice()) {
                    $scope.ovatRedDetailDTOListParam.adValoremTotal = globalFn.Mul($scope.ovatRedDetailDTOListParam.quantity, $scope.ovatRedDetailDTOListParam.taxPrice)
                }
                if (isPrice()) {
                    $scope.ovatRedDetailDTOListParam.amount = globalFn.Mul($scope.ovatRedDetailDTOListParam.quantity, $scope.ovatRedDetailDTOListParam.price)
                }
                calTaxAmount()
            } else {
                if (!isQuantity()) {
                    $scope.ovatRedDetailDTOListParam.quantity = ''
                    return
                }
                if (isPrice()) {
                    $scope.ovatRedDetailDTOListParam.amount = globalFn.Mul($scope.ovatRedDetailDTOListParam.quantity, $scope.ovatRedDetailDTOListParam.price)
                }
                if (isTaxPrice()) {
                    $scope.ovatRedDetailDTOListParam.adValoremTotal = globalFn.Mul($scope.ovatRedDetailDTOListParam.quantity, $scope.ovatRedDetailDTOListParam.taxPrice)
                }
                calTaxAmount()
            }
        }

        // 单价变化
        $scope.priceChange = function () {
            if (isTax()) {
                if (!isTaxPrice()) {
                    $scope.ovatRedDetailDTOListParam.taxPrice = ''
                    return
                }
                $scope.ovatRedDetailDTOListParam.price = globalFn.Div($scope.ovatRedDetailDTOListParam.taxPrice, globalFn.Add(1, $scope.ovatRedDetailDTOListParam.taxRate))
                if (isQuantity()) {
                    $scope.ovatRedDetailDTOListParam.adValoremTotal = globalFn.Mul($scope.ovatRedDetailDTOListParam.quantity, $scope.ovatRedDetailDTOListParam.taxPrice)
                    $scope.ovatRedDetailDTOListParam.amount = globalFn.Mul($scope.ovatRedDetailDTOListParam.quantity, $scope.ovatRedDetailDTOListParam.price)
                }
                if (isAdValoremTotal()) {
                    $scope.ovatRedDetailDTOListParam.quantity = globalFn.Div($scope.ovatRedDetailDTOListParam.adValoremTotal, $scope.ovatRedDetailDTOListParam.taxPrice)
                }
                calTaxAmount()
            } else {
                if (!isPrice()) {
                    $scope.ovatRedDetailDTOListParam.price = ''
                    return
                }
                $scope.ovatRedDetailDTOListParam.taxPrice = globalFn.Mul($scope.ovatRedDetailDTOListParam.price, globalFn.Add(1, $scope.ovatRedDetailDTOListParam.taxRate))
                if (isQuantity()) {
                    $scope.ovatRedDetailDTOListParam.adValoremTotal = globalFn.Mul($scope.ovatRedDetailDTOListParam.quantity, $scope.ovatRedDetailDTOListParam.taxPrice)
                    $scope.ovatRedDetailDTOListParam.amount = globalFn.Mul($scope.ovatRedDetailDTOListParam.quantity, $scope.ovatRedDetailDTOListParam.price)
                }
                if (isAmount()) {
                    $scope.ovatRedDetailDTOListParam.quantity = globalFn.Div($scope.ovatRedDetailDTOListParam.amount, $scope.ovatRedDetailDTOListParam.price)
                }

                calTaxAmount()
            }
        }

        // 金额变化
        $scope.amountChange = function () {
            if (isTax()) {
                if (!isAdValoremTotal()) {
                    $scope.ovatRedDetailDTOListParam.adValoremTotal = ''
                    return
                }
                $scope.ovatRedDetailDTOListParam.amount = globalFn.Div($scope.ovatRedDetailDTOListParam.adValoremTotal, globalFn.Add(1, $scope.ovatRedDetailDTOListParam.taxRate))
                if (isTaxPrice()) {
                    $scope.ovatRedDetailDTOListParam.quantity = globalFn.Div($scope.ovatRedDetailDTOListParam.adValoremTotal, $scope.ovatRedDetailDTOListParam.taxPrice)
                }
                calTaxAmount()
            } else {
                if (!isAmount()) {
                    $scope.ovatRedDetailDTOListParam.amount = ''
                    return
                }
                $scope.ovatRedDetailDTOListParam.adValoremTotal = globalFn.Mul($scope.ovatRedDetailDTOListParam.amount, globalFn.Add(1, $scope.ovatRedDetailDTOListParam.taxRate))
                if (isPrice()) {
                    $scope.ovatRedDetailDTOListParam.quantity = globalFn.Div($scope.ovatRedDetailDTOListParam.amount, $scope.ovatRedDetailDTOListParam.price)
                }
                calTaxAmount()
            }
        }

        // 删除商品行
        $scope.operatedMinus = function () {
            const _idList = getSelectedArr($scope.param.ovatRedDetailDTOList, 'selected', 'serialNo')
            if (_idList.length > 0) {
                let msg = ''
                let minusCallback
                msg = '确认删除这些商品吗?'
                minusCallback = function () {
                    for (let i = 0, l = _idList.length; i < l; i++) {
                        for (const a in $scope.param.ovatRedDetailDTOList) {
                            if ($scope.param.ovatRedDetailDTOList[a].serialNo === _idList[i]) {
                                $scope.param.ovatRedDetailDTOList.splice(a, 1)
                            }
                        }
                    }
                }

                // 弹出确认框

                sweetalert.swal({
                    title: '删除提醒',
                    text: msg,
                    // type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: '#0096e7',
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    closeOnConfirm: true,
                    closeOnCancel: true,
                }, (isConfirm) => {
                    if (isConfirm) {
                        // 确定处理
                        $scope.tb_isAllselected = false
                        minusCallback()
                        calTotalAmtTotalTaxamt()
                    }
                })
            } else {
                logger.logError('请先选择商品')
            }
        }


        // 新增提交
        // 是否暂存成功
        $scope.isSubmited = false
        $scope.submit = function () {
            let msg = '暂存成功'
            if ($scope.isSubmited) {
                msg = '提交成功'
            }
            httpRequest.post_addRedInfo($scope.param, msg).then((res) => {
                if (res.data.success) {
                    $scope.isSubmited = true
                }
                // $location.path("index/redInfo/list").replace()
            })
        }

        // post_getRedInfoListByIds

        // 打印预览
        $scope.printPreview = function () {
            // 弹窗
            const balanceModalData = []
            balanceModalData.push($scope.param) // 数据
            const modalInstance = $uibModal.open({
                template: require('./view/printPreview.html'),
                controller: 'modalPrintCtrl',
                backdrop: 'static',
                openedClass: 'mod-modal-print',
                resolve: {
                    items1() {
                        return balanceModalData
                    },
                    items2() {
                        return $scope.dictData
                    },
                },
            })
            modalInstance.result.then((item) => {
                console.log(item)
            }, () => {
                console.log(`Modal dismissed at: ${new Date()}`)
            })
        }

        /**
         * 表相关的控制方法
         * 后期抽离成组件
         * 全选 / 排序 / 分页 / 选中行
         */

        // 表格固有方法功能 -未来抽象为datagrid 组件
        // $scope.rows = $scope.param.ovatRedDetailDTOList;
        // 全选状态
        $scope.tb_isAllselected = false
        // 表格行点击方法
        $scope.tb_rowClcik = function (...arg) {
            $scope.tb_rowSelect(...arg)
        }
        // 表格行checkSelect 方法
        $scope.tb_rowSelect = function (idx, row) {
            // 全选
            let len = 0
            for (const a in $scope.param.ovatRedDetailDTOList) {
                if ($scope.param.ovatRedDetailDTOList[a].selected == true) len++
            }
            if (len == $scope.param.ovatRedDetailDTOList.length) {
                $scope.tb_isAllselected = true
            } else {
                $scope.tb_isAllselected = false
            }
        }
        // 表格行划过
        $scope.tb_rowhover = function (row, flag) {
            row.mouseenter = flag
        }
        // 按钮滑过
        $scope.dropdown_rowhover = function (row, flag) {
            row.dropdownhover = flag
        }
        // 表格全选
        $scope.tb_selectAll = function (val) {
            console.log(val)
            $scope.tb_isAllselected = val
            for (const a in $scope.param.ovatRedDetailDTOList) {
                $scope.param.ovatRedDetailDTOList[a].selected = $scope.tb_isAllselected
            }
        }


        // 获取选中id数组
        function getSelectedArr(arr, oldid, newid) {
            const selectedArr = []
            const o = arr
            for (const m in o) {
                if (o[m].hasOwnProperty(oldid) && o[m][oldid]) {
                    selectedArr.push(o[m][newid])
                }
            }
            return selectedArr
        }
    }
}

detailRedInfoCtrl.$inject = ['$scope', '$http', '$uibModal', 'logger', 'httpRequest', '$state', 'sweetalert', 'globalFn']
export default detailRedInfoCtrl



// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/redWordInfo/redInfoDetailCtrl.js